/*
 * SereniVida CL — Releasit Variant Enforcer
 *
 * Ports ONLY the Mexico "no preselected talla/options" behavior:
 *  1) Quantity Offers: clear preselection + block COD/anticipado until chosen
 *  2) Upsells: same, only when visible select has 2+ real options
 *
 * Does NOT touch ZIP, province COD guard, address altura, shipping, or XHR.
 */
(function () {
  'use strict';

  var PLACEHOLDER_ATTR = 'data-rsi-placeholder';
  var ERROR_CLASS = '_rsi-variant-empty';
  var WARNING_CLASS = '_rsi-variant-missing-warning';
  var SHOW_WARN_CLASS = '_rsi-show-missing-warning';
  var UPSELL_WARN_CLASS = '_rsi-upsell-variant-missing-warning';
  var UPSELL_SHOW_WARN = '_rsi-upsell-show-missing-warning';

  var ALL_VARIANT_SELECTORS = [
    'select[data-offer-num-multi-sel][data-option-num]',
    'select[data-offer-num]'
  ].join(',');
  var ALL_OFFER_VARIANT_SELECTORS = [
    '._rsi-quantity-offers select[data-offer-num-multi-sel][data-option-num]',
    '._rsi-quantity-offers select[data-offer-num]'
  ].join(',');

  function injectStyle() {
    if (document.getElementById('_rsi-variant-enforcer-style')) return;
    var css =
      'select.' + ERROR_CLASS + '{' +
        'outline:2px solid #d33 !important;' +
        'outline-offset:1px !important;' +
        'box-shadow:0 0 0 3px rgba(221,51,51,.15) !important;' +
      '}' +
      '._rsi-quantity-offers .' + WARNING_CLASS + '{' +
        'display:none;margin:12px 0 4px;padding:10px 12px;' +
        'border-radius:8px;background:#fdecea;border:1px solid #f5c6c2;' +
        'color:#8a1f1f;font-size:13px;font-weight:600;text-align:center;' +
        'line-height:1.4;' +
      '}' +
      '._rsi-quantity-offers.' + SHOW_WARN_CLASS + ' .' + WARNING_CLASS + '{' +
        'display:block;' +
      '}' +
      '#_rsi-cod-form-modal-upsell .' + UPSELL_WARN_CLASS + ',' +
      'form._rsi-modal-upsell .' + UPSELL_WARN_CLASS + '{' +
        'display:none;margin:12px 0 4px;padding:10px 12px;' +
        'border-radius:8px;background:#fdecea;border:1px solid #f5c6c2;' +
        'color:#8a1f1f;font-size:13px;font-weight:600;text-align:center;' +
        'line-height:1.4;' +
      '}' +
      '#_rsi-cod-form-modal-upsell.' + UPSELL_SHOW_WARN + ' .' + UPSELL_WARN_CLASS + ',' +
      'form._rsi-modal-upsell.' + UPSELL_SHOW_WARN + ' .' + UPSELL_WARN_CLASS + '{' +
        'display:block;' +
      '}';
    var style = document.createElement('style');
    style.id = '_rsi-variant-enforcer-style';
    style.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(style);
  }

  // ---------------------------------------------------------------------------
  // Quantity Offers
  // ---------------------------------------------------------------------------

  function placeholderLabelFor(select) {
    var container = select.closest('._rsi-quantity-offers-variant-selector-multi-sel-container');
    var name = container && container.querySelector('._rsi-quantity-offers-multi-sel-optname');
    var label = name ? (name.textContent || '').trim() : '';
    if (!label) label = 'talla';
    return 'Selecciona ' + label.toLowerCase();
  }

  function getAllOfferSelects() {
    return document.querySelectorAll(ALL_OFFER_VARIANT_SELECTORS);
  }

  function clearHiddenVariantId(select) {
    var subItem = select.closest('._rsi-quantity-offers-variant-selector-multi-sel');
    if (subItem) {
      var subItemHidden = subItem.querySelector('input[type="hidden"][data-offer-num]');
      if (subItemHidden) subItemHidden.value = '';
      return;
    }

    var offer = select.closest('._rsi-quantity-offers-offer-container');
    if (!offer) return;

    var hiddenInputs = offer.querySelectorAll(
      'input._rsi-quantity-offers-item-input[name^="item_variant_id"],' +
      'input[type="hidden"][name^="item_variant_id"]'
    );
    for (var i = 0; i < hiddenInputs.length; i++) hiddenInputs[i].value = '';
  }

  function syncHiddenVariantId(select) {
    if (!select || !select.matches('select[data-offer-num]')) return;

    var offer = select.closest('._rsi-quantity-offers-offer-container');
    if (!offer) return;

    var simpleSelects = offer.querySelectorAll('select[data-offer-num]');
    var hiddenInputs = offer.querySelectorAll(
      'input._rsi-quantity-offers-item-input[name^="item_variant_id"],' +
      'input[type="hidden"][name^="item_variant_id"]'
    );
    if (simpleSelects.length === 1 && hiddenInputs.length === 1) {
      hiddenInputs[0].value = select.value || '';
    }
  }

  function clearPreselection(select) {
    if (!select || select.getAttribute(PLACEHOLDER_ATTR) === '1') return;

    var opts = select.querySelectorAll('option');
    for (var i = 0; i < opts.length; i++) opts[i].removeAttribute('selected');

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.selected = true;
    placeholder.setAttribute(PLACEHOLDER_ATTR, '1');
    placeholder.textContent = placeholderLabelFor(select);
    select.insertBefore(placeholder, select.firstChild);
    select.value = '';
    select.setAttribute(PLACEHOLDER_ATTR, '1');

    clearHiddenVariantId(select);

    if (!select.__codOfferBound) {
      select.__codOfferBound = true;
      select.addEventListener('change', function () {
        syncHiddenVariantId(select);
        if (select.value) select.classList.remove(ERROR_CLASS);
        revalidateOffers();
      });
    }
  }

  function setupSelects() {
    var selects = getAllOfferSelects();
    for (var i = 0; i < selects.length; i++) clearPreselection(selects[i]);
  }

  function getSelectedOfferContainer() {
    return document.querySelector(
      '._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected'
    ) || document.querySelector('._rsi-quantity-offers-offer-container');
  }

  function getEmptySelectsInSelectedOffer() {
    var offer = getSelectedOfferContainer();
    if (!offer) return [];
    var selects = offer.querySelectorAll(ALL_VARIANT_SELECTORS);
    var empties = [];
    for (var i = 0; i < selects.length; i++) {
      if (!selects[i].value) empties.push(selects[i]);
    }
    return empties;
  }

  function ensureWarning() {
    var wrap = document.querySelector('._rsi-quantity-offers');
    if (!wrap) return null;
    var warn = wrap.querySelector('.' + WARNING_CLASS);
    if (!warn) {
      warn = document.createElement('div');
      warn.className = WARNING_CLASS;
      wrap.appendChild(warn);
    }
    var warningText = warningTextForSelectedOffer();
    if (warn.textContent !== warningText) warn.textContent = warningText;
    return warn;
  }

  function warningTextForSelectedOffer() {
    var offer = getSelectedOfferContainer();
    if (!offer) {
      return 'Por favor, selecciona las opciones de todos los pares antes de continuar.';
    }

    var selects = offer.querySelectorAll(ALL_VARIANT_SELECTORS);
    var hasTalla = false;
    var hasColor = false;

    for (var i = 0; i < selects.length; i++) {
      var label = placeholderLabelFor(selects[i]).replace(/^Selecciona\s+/i, '');
      if (label === 'talla') hasTalla = true;
      if (label === 'color') hasColor = true;
    }

    if (hasTalla && hasColor) {
      return 'Por favor, selecciona talla y color de todos los pares antes de continuar.';
    }
    if (hasTalla) {
      return 'Por favor, selecciona la talla de todos los pares antes de continuar.';
    }
    return 'Por favor, selecciona las opciones de todos los pares antes de continuar.';
  }

  function revalidateOffers() {
    var wrap = document.querySelector('._rsi-quantity-offers');
    if (!wrap) return;
    ensureWarning();
    if (getEmptySelectsInSelectedOffer().length === 0) {
      wrap.classList.remove(SHOW_WARN_CLASS);
      var selects = getAllOfferSelects();
      for (var i = 0; i < selects.length; i++) selects[i].classList.remove(ERROR_CLASS);
    }
  }

  function variantsComplete() {
    return getEmptySelectsInSelectedOffer().length === 0;
  }

  function flagMissing() {
    var empties = getEmptySelectsInSelectedOffer();
    for (var i = 0; i < empties.length; i++) empties[i].classList.add(ERROR_CLASS);

    var wrap = document.querySelector('._rsi-quantity-offers');
    if (wrap && empties.length) {
      wrap.classList.add(SHOW_WARN_CLASS);
      if (empties[0].scrollIntoView) {
        try { empties[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (e) { empties[0].scrollIntoView(); }
      }
    }
    return empties.length === 0;
  }

  function installSubmitGuards() {
    if (installSubmitGuards._done) return;

    document.addEventListener('click', function (ev) {
      var target = ev.target;
      if (!target || !target.closest) return;

      var codBtn = target.closest('._rsi-build-block-submit-button');
      var advBtn = target.closest('a._rsi-buy-now-custom-additionals-button');
      if (!codBtn && !advBtn) return;
      if (!document.querySelector('._rsi-quantity-offers')) return;

      if (!variantsComplete()) {
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        flagMissing();
      }
    }, true);

    installSubmitGuards._done = true;
  }

  // ---------------------------------------------------------------------------
  // Upsells (fixed MX logic: never wipe customer choice; skip products w/o sizes)
  // ---------------------------------------------------------------------------

  function getUpsellRoots() {
    return document.querySelectorAll('#_rsi-cod-form-modal-upsell, form._rsi-modal-upsell');
  }

  function isVisibleEl(el) {
    if (!el) return false;
    var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
    if (cs && (cs.display === 'none' || cs.visibility === 'hidden')) return false;
    var p = el.parentElement;
    while (p) {
      var ps = window.getComputedStyle ? window.getComputedStyle(p) : null;
      if (ps && ps.display === 'none') return false;
      p = p.parentElement;
    }
    return true;
  }

  function countRealOptions(select) {
    var opts = select.querySelectorAll('option');
    var n = 0;
    for (var i = 0; i < opts.length; i++) {
      var v = opts[i].value;
      if (v == null || String(v).trim() === '') continue;
      if (opts[i].getAttribute(PLACEHOLDER_ATTR) === '1') continue;
      n++;
    }
    return n;
  }

  function getRequiredUpsellSelects(root) {
    if (!root || !root.querySelectorAll) return [];
    var all = root.querySelectorAll(
      '._rsi-modal-upsell-variant-selector select, ._rsi-modal-upsell-variants select[data-option-name], select[data-option-name]'
    );
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var s = all[i];
      if (!isVisibleEl(s)) continue;
      if (countRealOptions(s) < 2) continue;
      out.push(s);
    }
    return out;
  }

  function placeholderLabelForUpsell(select) {
    var item = select.closest('._rsi-modal-upsell-variant-selector, ._rsi-modal-fields-item');
    var labelEl = item && item.querySelector('label');
    var label = labelEl ? (labelEl.textContent || '').trim() : '';
    if (!label) label = select.getAttribute('data-option-name') || 'opción';
    return 'Selecciona ' + label.toLowerCase();
  }

  function clearUpsellPreselection(select) {
    if (!select) return;
    // Already processed — NEVER wipe the customer's choice
    if (select.getAttribute(PLACEHOLDER_ATTR) === '1') return;
    if (countRealOptions(select) < 2) return;

    var opts = select.querySelectorAll('option');
    for (var i = 0; i < opts.length; i++) opts[i].removeAttribute('selected');

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.selected = true;
    placeholder.setAttribute(PLACEHOLDER_ATTR, '1');
    placeholder.textContent = placeholderLabelForUpsell(select);
    select.insertBefore(placeholder, select.firstChild);
    select.value = '';
    select.setAttribute(PLACEHOLDER_ATTR, '1');

    if (!select.__codUpsellBound) {
      select.__codUpsellBound = true;
      select.addEventListener('change', function () {
        var root = select.closest('#_rsi-cod-form-modal-upsell, form._rsi-modal-upsell');
        if (select.value) select.classList.remove(ERROR_CLASS);
        if (root && upsellVariantsComplete(root)) hideUpsellWarning(root);
      });
    }
  }

  function ensureUpsellWarning(root) {
    if (!root) return null;
    var warn = root.querySelector('.' + UPSELL_WARN_CLASS);
    if (!warn) {
      warn = document.createElement('div');
      warn.className = UPSELL_WARN_CLASS;
      warn.textContent = 'Por favor, selecciona la talla antes de aceptar la oferta.';
      var variants = root.querySelector('._rsi-modal-upsell-variants');
      if (variants && variants.parentNode) {
        variants.parentNode.insertBefore(warn, variants.nextSibling);
      } else {
        var btn = root.querySelector('#_rsi-modal-submit-button-upsell, ._rsi-modal-submit-button-upsell');
        if (btn && btn.parentNode) btn.parentNode.insertBefore(warn, btn);
        else root.appendChild(warn);
      }
    }
    return warn;
  }

  function hideUpsellWarning(root) {
    if (!root) return;
    root.classList.remove(UPSELL_SHOW_WARN);
    var warn = root.querySelector('.' + UPSELL_WARN_CLASS);
    if (warn) warn.style.display = 'none';
    var selects = getRequiredUpsellSelects(root);
    for (var i = 0; i < selects.length; i++) selects[i].classList.remove(ERROR_CLASS);
  }

  function upsellVariantsComplete(root) {
    var selects = getRequiredUpsellSelects(root);
    if (!selects.length) return true;
    for (var i = 0; i < selects.length; i++) {
      if (!selects[i].value) return false;
    }
    return true;
  }

  function flagUpsellMissing(root) {
    var selects = getRequiredUpsellSelects(root);
    var empties = [];
    for (var i = 0; i < selects.length; i++) {
      if (!selects[i].value) {
        selects[i].classList.add(ERROR_CLASS);
        empties.push(selects[i]);
      }
    }
    if (empties.length) {
      var warn = ensureUpsellWarning(root);
      if (warn) warn.style.display = 'block';
      root.classList.add(UPSELL_SHOW_WARN);
      if (empties[0].scrollIntoView) {
        try { empties[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (e) { empties[0].scrollIntoView(); }
      }
    }
    return empties.length === 0;
  }

  function setupUpsellSelects() {
    var roots = getUpsellRoots();
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      var required = getRequiredUpsellSelects(root);
      if (!required.length) {
        hideUpsellWarning(root);
        continue;
      }
      for (var i = 0; i < required.length; i++) clearUpsellPreselection(required[i]);
      if (upsellVariantsComplete(root)) hideUpsellWarning(root);
    }
  }

  function installUpsellSubmitGuards() {
    if (installUpsellSubmitGuards._done) return;

    document.addEventListener('click', function (ev) {
      var target = ev.target;
      if (!target || !target.closest) return;

      if (target.closest('#_rsi-modal-submit-button-upsell-no-thanks, ._rsi-modal-submit-button-upsell-no-thanks')) {
        return;
      }

      var accept = target.closest(
        '#_rsi-modal-submit-button-upsell, button._rsi-modal-submit-button-upsell'
      );
      if (!accept) return;
      if (accept.classList && accept.classList.contains('_rsi-modal-submit-button-upsell-no-thanks')) return;

      var root = accept.closest('#_rsi-cod-form-modal-upsell, form._rsi-modal-upsell')
        || document.querySelector('#_rsi-cod-form-modal-upsell, form._rsi-modal-upsell');
      if (!root) return;

      var required = getRequiredUpsellSelects(root);
      if (!required.length) return;

      if (!upsellVariantsComplete(root)) {
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        flagUpsellMissing(root);
      }
    }, true);

    installUpsellSubmitGuards._done = true;
  }

  // ---------------------------------------------------------------------------
  // Bootstrap
  // ---------------------------------------------------------------------------

  function tick() {
    setupSelects();
    ensureWarning();
    setupUpsellSelects();
  }

  function start() {
    injectStyle();
    installSubmitGuards();
    installUpsellSubmitGuards();
    tick();

    new MutationObserver(tick).observe(document.body, {
      childList: true,
      subtree: true
    });

    var c = 0;
    var iv = setInterval(function () {
      tick();
      if (++c > 120) clearInterval(iv);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
